export const BILLING_COMPONENTS_TRANSLATION_NAMESPACE = "billing-components";

export const BILLING_COMPONENTS_COMMON_TK = "BILLING_COMPONENTS_COMMON_TK";
